export enum SessionStorageKeys {
  SHOP_IN_US = "shop_in_us",
}
